(() => {
  'use strict';

  if (window.__mellerQuickAddNoVisualFastReady) return;
  window.__mellerQuickAddNoVisualFastReady = true;

  const closestRoot = (target) => {
    if (!target || !target.closest) return null;
    return target.closest('[data-meller-quick-add-root]');
  };

  const getLiveRegion = (root) => {
    if (!root) return null;
    return root.querySelector('[data-meller-quick-add-live-region]');
  };

  const getAddButton = (root) => {
    if (!root) return null;
    return root.querySelector('.quick-add__button--add');
  };

  const clearBusy = (root) => {
    if (!root) return;

    const button = getAddButton(root);

    root.removeAttribute('data-meller-quick-add-busy');

    if (button) {
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      const button = event.target && event.target.closest
        ? event.target.closest('.quick-add__button--add')
        : null;

      if (!button || button.disabled) return;

      const root = closestRoot(button);
      if (!root) return;

      root.setAttribute('data-meller-quick-add-prepared', 'true');
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

      const root = closestRoot(form);
      if (!root) return;

      const variantInput = form.querySelector('input[name="id"]');
      const button = getAddButton(root);
      const liveRegion = getLiveRegion(root);

      if (!variantInput || variantInput.disabled || !variantInput.value || !button || button.disabled) return;

      root.setAttribute('data-meller-quick-add-busy', 'true');
      button.setAttribute('aria-busy', 'true');

      if (liveRegion) {
        liveRegion.textContent = 'Agregando producto al carrito';
      }

      window.setTimeout(() => {
        clearBusy(root);
      }, 2500);
    },
    true
  );

  [
    'cart:update',
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'product-form:success',
    'ajaxProduct:added'
  ].forEach((eventName) => {
    document.addEventListener(
      eventName,
      () => {
        const roots = document.querySelectorAll('[data-meller-quick-add-root][data-meller-quick-add-busy]');

        roots.forEach((root) => {
          clearBusy(root);
        });
      },
      true
    );
  });
})();
